import { ReflectUtils } from "@dooboostore/core";
const SUBSCRIBE_SWC_APP_ROUTE_CHANGE_METADATA_KEY = Symbol.for("simple-web-component:subscribe-swc-app-route-change");
function createSubscribeSwcAppRouteChange(options) {
  return (target, propertyKey, descriptor) => {
    const pathPattern = options?.path;
    const filter = options?.filter;
    const constructor = target.constructor;
    let list = ReflectUtils.getOwnMetadata(SUBSCRIBE_SWC_APP_ROUTE_CHANGE_METADATA_KEY, constructor);
    if (!list) {
      list = [];
      ReflectUtils.defineMetadata(SUBSCRIBE_SWC_APP_ROUTE_CHANGE_METADATA_KEY, list, constructor);
    }
    list.push({ propertyKey, options });
    return descriptor;
  };
}
function subscribeSwcAppRouteChange(targetOrOptions, propertyKeyOrConfig, descriptor) {
  if (propertyKeyOrConfig && (typeof propertyKeyOrConfig === "string" || typeof propertyKeyOrConfig === "symbol")) {
    return createSubscribeSwcAppRouteChange({})(targetOrOptions, propertyKeyOrConfig, descriptor);
  }
  let options = {};
  if (Array.isArray(targetOrOptions)) {
    options.path = targetOrOptions;
    if (propertyKeyOrConfig && typeof propertyKeyOrConfig === "object") {
      options = { ...options, ...propertyKeyOrConfig };
    }
  } else if (typeof targetOrOptions === "string" || typeof targetOrOptions === "function") {
    options.path = targetOrOptions;
    if (propertyKeyOrConfig && typeof propertyKeyOrConfig === "object") {
      options = { ...options, ...propertyKeyOrConfig };
    }
  } else if (targetOrOptions && typeof targetOrOptions === "object") {
    options = targetOrOptions;
  }
  return createSubscribeSwcAppRouteChange(options);
}
const changedRoute = subscribeSwcAppRouteChange;
function subscribeSwcAppRouteChangeConnectedDone(pathPattern, config) {
  return subscribeSwcAppRouteChange(pathPattern, { ...config, trigger: "connectedDone" });
}
const getSubscribeSwcAppRouteChangeMetadata = (target) => {
  const constructor = typeof target === "function" ? target : target.constructor;
  const results = ReflectUtils.findAllMetadata(SUBSCRIBE_SWC_APP_ROUTE_CHANGE_METADATA_KEY, constructor).flat();
  if (!results) return [];
  return [...results].sort((a, b) => (a.options?.order ?? 0) - (b.options?.order ?? 0));
};
class RouteSubscribeLifeCycler {
  onConnected(_helperHostSet) {
  }
  /** SwcAppMixin 이 구독 대상 메타를 꺼낼 때 사용 */
  getMetadata(helperHostSet) {
    return getSubscribeSwcAppRouteChangeMetadata(helperHostSet.$this);
  }
}
export {
  RouteSubscribeLifeCycler,
  SUBSCRIBE_SWC_APP_ROUTE_CHANGE_METADATA_KEY,
  changedRoute,
  getSubscribeSwcAppRouteChangeMetadata,
  subscribeSwcAppRouteChange,
  subscribeSwcAppRouteChangeConnectedDone
};
//# sourceMappingURL=subscribeSwcAppRouteChange.js.map
